import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont"
    >
      <path
        d="M7.3 9.1c.495 0 .9.405.9.9v3.6c0 .495-.405.9-.9.9a.903.903 0 0 1-.9-.9V10c0-.495.405-.9.9-.9Zm5.4 0c.495 0 .9.405.9.9v3.6c0 .495-.405.9-.9.9a.903.903 0 0 1-.9-.9V10c0-.495.405-.9.9-.9Zm2.7 7.2a.9.9 0 0 1-.9.9h-9a.9.9 0 0 1-.9-.9V6.4h10.8v9.9ZM8.2 3.095c0-.14.193-.295.45-.295h2.7c.257 0 .45.156.45.295V4.6H8.2V3.095ZM18.1 4.6h-4.5V3.095C13.6 1.94 12.591 1 11.35 1h-2.7C7.409 1 6.4 1.94 6.4 3.095V4.6H1.9c-.495 0-.9.405-.9.9s.405.9.9.9h.9v9.9c0 1.489 1.211 2.7 2.7 2.7h9c1.489 0 2.7-1.211 2.7-2.7V6.4h.9c.495 0 .9-.405.9-.9s-.405-.9-.9-.9Z"
        fill="#2980D0"
      />
    </svg>
  )
}
const RecycleIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
RecycleIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'rgb(var(--ow-primary-color))',
}
// 参数类型
RecycleIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default RecycleIcon
